export const THEME_MODE_STORAGE_KEY = 'theme';
export const THEME_MODE_ATTRIBUTE = 'theme';
export const THEME_MODE_LIGHT = 'light';
export const THEME_MODE_DARK = 'dark';

export const normalizeThemeMode = (themeMode) => {
    return themeMode === THEME_MODE_DARK ? THEME_MODE_DARK : THEME_MODE_LIGHT;
};

export const isDarkThemeMode = (themeMode) => {
    return normalizeThemeMode(themeMode) === THEME_MODE_DARK;
};

const syncToastEditorTheme = (isDarkMode) => {
    if (typeof window === 'undefined' || typeof $ === 'undefined') {
        return;
    }

    const method = isDarkMode ? 'addClass' : 'removeClass';

    $('.toastui-editor-defaultUI')[method]('toastui-editor-dark');
    $('.toastui-editor-contents').parent()[method]('toastui-editor-dark');
};

export const getStoredThemeMode = () => {
    if (typeof window === 'undefined') {
        return THEME_MODE_LIGHT;
    }

    return normalizeThemeMode(window.localStorage.getItem(THEME_MODE_STORAGE_KEY));
};

export const applyThemeMode = (themeMode, store = null) => {
    const normalizedThemeMode = normalizeThemeMode(themeMode);
    const darkMode = isDarkThemeMode(normalizedThemeMode);

    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute(THEME_MODE_ATTRIBUTE, normalizedThemeMode);
    }

    if (typeof window !== 'undefined') {
        window.localStorage.setItem(THEME_MODE_STORAGE_KEY, normalizedThemeMode);
    }

    if (store?.state?.theme) {
        if (typeof store.commit === 'function') {
            store.commit('SET_DARK_MODE', darkMode);
        } else {
            store.state.theme.darkMode = darkMode;
        }
    }

    syncToastEditorTheme(darkMode);

    return normalizedThemeMode;
};

export const initializeThemeMode = (store = null) => {
    return applyThemeMode(getStoredThemeMode(), store);
};
